module.exports = __webpack_public_path__ + "media/typing.4babde5a.mp3";